const Builder = require('./BuilderBase');
const HiddenFor = require('./HiddenFor');

module.exports = class DropDownCriteria extends Builder {
    constructor(title, properties) {
        super('workflowCriteriaElement_DropDownCriteria', title, properties);
        if (!properties.namespace || !properties.relation) {
            throw new Error('For DropDowns you must specify a namespace and a relation.');
        }
    }
    hiddenFor(role) {
        let hiddenFor = new HiddenFor(role);
        this.addChildBlock(hiddenFor, 'securityModifier');
        return this;
    }
};
